module.exports = __webpack_public_path__ + "img/230.general_arrangement.8275b2c9.svg";